import type {DiffDelta} from '@github-ui/diff-file-tree'
import {DiffFileTree} from '@github-ui/diff-file-tree'
import {SearchIcon, XCircleFillIcon} from '@primer/octicons-react'
import {TextInput, sx} from '@primer/react'
import {debounce} from '@github/mini-throttle'
import {useState, useRef, useEffect} from 'react'

export type FileTreeProps = {
  activeFilePath?: string
  diffs: DiffDelta[]
  onSelect: (file: DiffDelta) => void
}

export function FileTree({diffs, onSelect}: FileTreeProps) {
  const [query, setTextValue] = useState('')

  const filteredDiffs = query ? diffs.filter(diff => diff.path.toLowerCase().includes(query.toLowerCase())) : diffs

  return (
    <div className="d-flex flex-column gap-2">
      <SearchBox query={query} onSearch={setTextValue} />
      {/* //TODO - empty results */}
      <DiffFileTree activeFilePath="" diffs={filteredDiffs} onSelect={onSelect} />
    </div>
  )
}

type SearchBoxProps = {
  query: string
  onSearch(query: string): void
}

function SearchBox({query, onSearch}: SearchBoxProps) {
  const [textValue, setTextValue] = useState(query)
  const debouncedOnSearch = useRef(debounce((newQuery: string) => onSearch(newQuery), 250))

  useEffect(() => {
    setTextValue(query)
  }, [query])

  const clearAction = query ? (
    <TextInput.Action
      onClick={() => {
        onSearch('')
      }}
      icon={XCircleFillIcon}
      aria-label="Clear"
      sx={{color: 'fg.subtle'}}
    />
  ) : undefined

  return (
    <TextInput
      // ref={ref}
      // aria-activedescendant={ariaActiveDescendant}
      value={textValue}
      onChange={e => {
        setTextValue(e.target.value)
        debouncedOnSearch.current(e.target.value)
      }}
      sx={{display: 'flex', ...sx}}
      aria-label="Filter files"
      autoCorrect="off"
      spellCheck="false"
      placeholder="Filter files"
      leadingVisual={SearchIcon}
      trailingAction={clearAction}
    />
  )
}

try{ FileTree.displayName ||= 'FileTree' } catch {}
try{ SearchBox.displayName ||= 'SearchBox' } catch {}